// Something@something.domain with no spaces. The old pattern allowed only
// letters, digits, ".", "_" and "-" before the @ and domain endings of at most
// 6 letters, so "name+tag@…" or "…@studio.photography" could never ask for a
// password reset.
export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  return emailRegex.test(email);
}
